/**
 * 「詳細」から開く画面を決める。
 *
 * ステークホルダーの設問はスプレッドシート側にあり、台本画面を開いても空になる。
 * 代わりに録画と文字起こしを見る画面へ行く。
 */
export function resolveInterviewDetailPath(interview: {
  interviewId: string;
  stakeholderContext: unknown | null;
}): string {
  return interview.stakeholderContext
    ? `/employee_interview/stakeholder-interviews/${interview.interviewId}`
    : `/employee_interview/interviewer/scripts/${interview.interviewId}`;
}
